import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'reactstrap';
import moment from 'moment';

import Table, { ExpandableRow, ExpandedRow } from '../../components/ExpandableTable';

import actions from './actions';

class ListNotificacoes extends Component {
  componentDidMount () {
    this.props.actions.onLoadNotificacoes();
  }

  close = value => e => {
    e.stopPropagation();

    this.props.actions.closeNotification(value);
  };

  closeAll = e => {
    this.props.actions.closeAllNotifications();
  };

  render () {
    const { value: { result } } = this.props;

    return (<Table hover responsive size="sm">
      <thead>
        <tr>
          <th><Button disabled={!result.length} size="sm" color="link" onClick={this.closeAll} title="Fechar todos"><span className="fa fa-times"></span></Button>Título</th>
          <th className="d-none d-sm-table-cell">Data</th>
          <th className="d-none d-sm-table-cell">Remetente</th>
        </tr>
      </thead>
      {result.map(v => <ExpandableRow key={v.id}>
        <td><Button size="sm" color="link" onClick={this.close(v)}><span className="fa fa-times"></span></Button>{v.title}</td>
        <td className="d-none d-sm-table-cell">{moment(v.created_at).calendar()}</td>
        <td className="d-none d-sm-table-cell">{v.sender}</td>
        <ExpandedRow>
          <div className="d-sm-none">{moment(v.created_at).calendar()} - {v.sender}</div>
          {v.body}
        </ExpandedRow>
      </ExpandableRow>)}
      {!result.length && <tbody>
        <tr><td colSpan="3">Sem notificações</td></tr>
      </tbody>}
    </Table>);
  }
}

let mapStateToProps = ({ notificacao: { notificacoes } }) => ({
  value: notificacoes
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListNotificacoes);



// WEBPACK FOOTER //
// ./src/modules/notificacao/ListaNotificacoes.js